export class AuditPackage {
  readonly auditPackageID: number;
  readonly projectID: number;
  readonly chaseID?: number;
  readonly memberID?: number;
  readonly numeratorID?: number;
  readonly auditReady: string;
  readonly status: string;
  readonly modifyUserID: number;
  readonly modifyDate: Date;

  constructor(options: {
    auditPackageID: number;
    projectID: number;
    chaseID?: number;
    memberID?: number;
    numeratorID?: number;
    auditReady: string;
    status: string;
    modifyUserID: number;
    modifyDate: Date;
  }) {
    this.auditPackageID = options.auditPackageID;
    this.projectID = options.projectID;
    this.chaseID = options.chaseID;
    this.memberID = options.memberID;
    this.numeratorID = options.numeratorID;
    this.auditReady = options.auditReady;
    this.status = options.status;
    this.modifyUserID = options.modifyUserID;
    this.modifyDate = options.modifyDate;
  }

}
